import React from 'react'
import { Box, StackView } from '@planningcenter/tapestry-react'
import { token } from '@planningcenter/tapestry'

const Input = ({ ...props }) => {
  const styles = { fontSize: '14px', lineHeight: '16px', margin: '0 8px' }
  return <Box as="input" style={styles} {...props} />
}

const Label = ({ selected, ...props }) => {
  const styles = {
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    lineHeight: '16px',
    marginBottom: '4px',
    padding: '8px 4px',
    background: token('--t-form-background-color'),
    borderWidth: '1px',
    borderColor: selected
      ? token('--t-form-border-color-focus')
      : token('--t-form-border-color'),
    ':hover': {
      borderColor: selected
        ? token('--t-form-border-color-focus')
        : token('--t-form-border-color-hover'),
    },
    ':last-child': { marginBottom: '0px' },
  }

  return <StackView as="label" axis="horizontal" {...props} css={styles} />
}

const Text = ({ ...props }) => {
  const styles = {
    fontSize: '14px',
    lineHeight: '16px',
    userSelect: 'none',
  }
  return <Box as="span" {...props} css={styles} />
}

const FormInput = ({ children, selected, ...props }) => {
  return (
    <Label key={props.name} htmlFor={props.id} selected={selected}>
      <Input {...props} />
      <Text>{children}</Text>
    </Label>
  )
}

export default FormInput
